import React, { useEffect, useState } from 'react';

import { blue, grey } from '@mui/material/colors';

import { makeStyles } from '@material-ui/core/styles';
import Avatar         from '@material-ui/core/Avatar';
import IconButton     from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField      from '@material-ui/core/TextField';

import '../Main.css';

import { date } from '../util';

const recreate = {
  printing: () => {
    return {
      margin: {
        paperBottom   : 1.0,
        paperLeft     : 1.0,
        paperRight    : 1.0,
        paperTop      : 1.0,
        scheduleBottom: 0.8,
        scheduleTop   : 0.1,
      },
      columnWidth: [2.5, 2.5, 2.5, 2.5, 2.5, 2.5, 3.8],
      days: [0, 1, 2, 3, 4, 5, 6],
      date: ['', '', '', '', '', '', ''],
      fontSize: {
        attender: 12.5,
        day: 14,
        title: 15,
      },
    };
  }
};

const style = {
  timetablePrintable: makeStyles((theme) => ({
    attenderName: {
      display: 'inline-block',
      marginRight: '5px',
    },
    column: {
      borderRight: '1px solid lightgrey',
      display: 'inline-block',
      flex: 1,
      flexDirection: 'column',
      height: '100%',
      verticalAlign: 'top',
      whiteSpace: 'normal',
    },
    days: {
      borderLeft: '1px solid lightgrey',
      flexGrow: 1,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    page: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      backgroundColor: 'white',
    },
    root: {
      display: 'flex',
      backgroundColor: 'gainsboro',
    },
    schedule: {
      borderTop: '1px solid lightgrey',
      textAlign: 'center',
    },
    scheduleDay: {
      borderTop: '1px solid lightgrey',
      paddingBottom: '0.15cm',
      paddingTop: '0.15cm',
      textAlign: 'center',
    },
    setting: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: theme.spacing(2),
      gap: theme.spacing(2),
    },
    settings: {
      padding: theme.spacing(2),
    },
    ticketer: {
      padding: '0px 0px 10px 5px',
    },
  })),
}

export default function TimetablePrintable(props) {
  const classes = style.timetablePrintable();

  const [ ticketerName, setTicketerName ] = useState('');
  const [ printing, setPrinting ] = useState(recreate.printing());

  const { ticketer, ticketers } = props.context.getStates();

  useEffect(() => {
    for (var i = 0; i < ticketers.length; i++) {
      if (ticketers[i].rowid === ticketer) {
        setTicketerName(ticketers[i].name)
        break;
      }
    }

    let newDate = [];
    const today = new Date();
    for (i = today.getDay(); i > 0; i--) {
      const day = new Date(today.getTime() - 1000 * 60 * 60 * 24 * i);
      newDate.push(`${day.getMonth() + 1}/${day.getDate()}`);
    }
    newDate.push(`${today.getMonth() + 1}/${today.getDate()}`);
    for (i = 1; i < 7 - today.getDay(); i++) {
      const day = new Date(today.getTime() + 1000 * 60 * 60 * 24 * i);
      newDate.push(`${day.getMonth() + 1}/${day.getDate()}`);
    }
    setPrinting((oldPrinting) => ({...oldPrinting, date: newDate}));
  }, [
    ticketer,
    ticketers,
  ]);

  return (
    <div className={classes.root}>
      <div style={{flexGrow: '1'}}></div>

      <div className={classes.page} style={{
        paddingBottom: `${printing.margin.paperBottom}cm`,
        paddingLeft  : `${printing.margin.paperLeft}cm`,
        paddingRight : `${printing.margin.paperRight}cm`,
        paddingTop   : `${printing.margin.paperTop}cm`,

        height: `${29.7 - printing.margin.paperTop - printing.margin.paperBottom}cm`,
        width: `${21 - printing.margin.paperLeft - printing.margin.paperRight}cm`,

        fontSize: `${printing.fontSize.attender}px`,
      }}>
        <div className={classes.ticketer} style={{ fontSize: `${printing.fontSize.title}px` }}>
          <b>{`${ticketerName} 일정`}</b> {`(${date.withoutTime(Date.now())} 기준)`}
        </div>

        <div className={classes.days}>
          {printing.days.map(day => (
            <div key={day} className={classes.column} style={{
              width: `${printing.columnWidth[day]}cm`,
            }}>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
              }}>
                <div className={classes.scheduleDay} style={{ fontSize: `${printing.fontSize.day}px` }}>
                  {`${printing.date[day]} (${'일월화수목금토'[day]})`}
                </div>

                {props.timetable[day].map((schedule, index) => (
                  <div key={index} schedule={schedule}
                    className={classes.schedule}
                    style={{
                      paddingBottom: `${printing.margin.scheduleBottom}cm`,
                      paddingTop: `${printing.margin.scheduleTop}cm`,
                    }}
                  >
                    <b>{
                      date.HHmm(schedule.secondsFrom) + ' - ' +
                      date.HHmm(schedule.secondsTo)
                    }</b>

                    {schedule.name === '' ? (
                      <div className={classes.scheduleHeadEmpty}></div>
                    ) : (
                      <div className={classes.scheduleHead}>
                        <u>{schedule.name}</u>
                      </div>
                    )}

                    {schedule.attendings.map(attending => (
                      <span key={attending.attenderRowid} className={classes.attenderName}>
                        {attending.attenderName + ','}
                      </span>
                    ))}
                  </div>
                ))}

                <div style={{
                  borderBottom: '1px solid lightgrey',
                  flexGrow: 1,
                }}></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{flexGrow: '1'}}></div>

      <div className={'not-printable'} style={{backgroundColor: 'white',}}>
        <div className={classes.settings}>
          <div className={classes.setting}>
            <b>{'여백'}</b>
            <TextField type="number" size="small" label="용지: 위쪽" variant="outlined"
              InputProps={{ endAdornment: <InputAdornment position="end">{'cm'}</InputAdornment> }}
              InputLabelProps={{ shrink: true, }}
              inputProps={{ min: 0, step: '0.1', }}
              onChange={(event) => { setPrinting({...printing, margin: {...printing.margin, paperTop: event.target.value}}); }}
              value={printing.margin.paperTop}
            />
            <TextField type="number" size="small" label="용지: 아래쪽" variant="outlined"
              InputProps={{ endAdornment: <InputAdornment position="end">{'cm'}</InputAdornment> }}
              InputLabelProps={{ shrink: true, }}
              inputProps={{ min: 0, step: '0.1', }}
              onChange={(event) => { setPrinting({...printing, margin: {...printing.margin, paperBottom: event.target.value}}); }}
              value={printing.margin.paperBottom}
            />
            <TextField type="number" size="small" label="용지: 왼쪽" variant="outlined"
              InputProps={{ endAdornment: <InputAdornment position="end">{'cm'}</InputAdornment> }}
              InputLabelProps={{ shrink: true, }}
              inputProps={{ min: 0, step: '0.1', }}
              onChange={(event) => { setPrinting({...printing, margin: {...printing.margin, paperLeft: event.target.value}}); }}
              value={printing.margin.paperLeft}
            />
            <TextField type="number" size="small" label="용지: 오른쪽" variant="outlined"
              InputProps={{ endAdornment: <InputAdornment position="end">{'cm'}</InputAdornment> }}
              InputLabelProps={{ shrink: true, }}
              inputProps={{ min: 0, step: '0.1', }}
              onChange={(event) => { setPrinting({...printing, margin: {...printing.margin, paperRight: event.target.value}}); }}
              value={printing.margin.paperRight}
            />

            <TextField type="number" size="small" label="일정: 위쪽" variant="outlined"
              InputProps={{ endAdornment: <InputAdornment position="end">{'cm'}</InputAdornment> }}
              InputLabelProps={{ shrink: true, }}
              inputProps={{ min: 0, step: '0.1', }}
              onChange={(event) => { setPrinting({...printing, margin: {...printing.margin, scheduleTop: event.target.value}}); }}
              value={printing.margin.scheduleTop}
            />
            <TextField type="number" size="small" label="일정: 아래쪽" variant="outlined"
              InputProps={{ endAdornment: <InputAdornment position="end">{'cm'}</InputAdornment> }}
              InputLabelProps={{ shrink: true, }}
              inputProps={{ min: 0, step: '0.1', }}
              onChange={(event) => { setPrinting({...printing, margin: {...printing.margin, scheduleBottom: event.target.value}}); }}
              value={printing.margin.scheduleBottom}
            />
          </div>

          <div className={classes.setting}>
            <b>{'요일'}</b>
            <div>
            {(() => {
              let days1 = [];
              let days2 = [];

              for (const day of printing.days) {
                days1.push(day);
              }
              for (const day of [0, 1, 2, 3, 4, 5, 6]) {
                if (!days1.includes(day)) {
                  days2.push(day);
                }
              }

              return [...days1, ...days2];
            })().map(day => (
              <IconButton key={day} size={'small'}
                onClick={(event) => {
                  let newDays = [];

                  let deselected = false;
                  for (const oldDay of printing.days) {
                    if (oldDay === day) {
                      deselected = true;
                    } else {
                      newDays.push(oldDay);
                    }
                  }
                  if (!deselected) {
                    newDays.push(day);
                  }

                  setPrinting({...printing, days: newDays});
                }}
              >
                <Avatar style={{
                  backgroundColor: printing.days.some((printingDay) => printingDay === day) ? blue[400] : grey['400'],
                }}>{'일월화수목금토'[day]}</Avatar>
              </IconButton>
            ))}
            </div>

            <TextField type="number" size="small" label="너비: 월요일" variant="outlined"
              InputLabelProps={{ shrink: true, }}
              InputProps={{ endAdornment: <InputAdornment position="end">{'cm'}</InputAdornment> }}
              inputProps={{ min: 0, step: 0.1, }}
              onChange={(event) => {
                let newColumnWidth = printing.columnWidth;
                newColumnWidth[1] = event.target.value;
                setPrinting({...printing, columnWidth: newColumnWidth});
              }}
              value={printing.columnWidth[1]}
            />
            <TextField type="number" size="small" label="너비: 화요일" variant="outlined"
              InputLabelProps={{ shrink: true, }}
              InputProps={{ endAdornment: <InputAdornment position="end">{'cm'}</InputAdornment> }}
              inputProps={{ min: 0, step: 0.1, }}
              onChange={(event) => {
                let newColumnWidth = printing.columnWidth;
                newColumnWidth[2] = event.target.value;
                setPrinting({...printing, columnWidth: newColumnWidth});
              }}
              value={printing.columnWidth[2]}
            />
            <TextField type="number" size="small" label="너비: 수요일" variant="outlined"
              InputLabelProps={{ shrink: true, }}
              InputProps={{ endAdornment: <InputAdornment position="end">{'cm'}</InputAdornment> }}
              inputProps={{ min: 0, step: 0.1, }}
              onChange={(event) => {
                let newColumnWidth = printing.columnWidth;
                newColumnWidth[3] = event.target.value;
                setPrinting({...printing, columnWidth: newColumnWidth});
              }}
              value={printing.columnWidth[3]}
            />
            <TextField type="number" size="small" label="너비: 목요일" variant="outlined"
              InputLabelProps={{ shrink: true, }}
              InputProps={{ endAdornment: <InputAdornment position="end">{'cm'}</InputAdornment> }}
              inputProps={{ min: 0, step: 0.1, }}
              onChange={(event) => {
                let newColumnWidth = printing.columnWidth;
                newColumnWidth[4] = event.target.value;
                setPrinting({...printing, columnWidth: newColumnWidth});
              }}
              value={printing.columnWidth[4]}
            />
            <TextField type="number" size="small" label="너비: 금요일" variant="outlined"
              InputLabelProps={{ shrink: true, }}
              InputProps={{ endAdornment: <InputAdornment position="end">{'cm'}</InputAdornment> }}
              inputProps={{ min: 0, step: 0.1, }}
              onChange={(event) => {
                let newColumnWidth = printing.columnWidth;
                newColumnWidth[5] = event.target.value;
                setPrinting({...printing, columnWidth: newColumnWidth});
              }}
              value={printing.columnWidth[5]}
            />
            <TextField type="number" size="small" label="너비: 토요일" variant="outlined"
              InputLabelProps={{ shrink: true, }}
              InputProps={{ endAdornment: <InputAdornment position="end">{'cm'}</InputAdornment> }}
              inputProps={{ min: 0, step: 0.1, }}
              onChange={(event) => {
                let newColumnWidth = printing.columnWidth;
                newColumnWidth[6] = event.target.value;
                setPrinting({...printing, columnWidth: newColumnWidth});
              }}
              value={printing.columnWidth[6]}
            />
            <TextField type="number" size="small" label="너비: 일요일" variant="outlined"
              InputLabelProps={{ shrink: true, }}
              InputProps={{ endAdornment: <InputAdornment position="end">{'cm'}</InputAdornment> }}
              inputProps={{ min: 0, step: 0.1, }}
              onChange={(event) => {
                let newColumnWidth = printing.columnWidth;
                newColumnWidth[0] = event.target.value;
                setPrinting({...printing, columnWidth: newColumnWidth});
              }}
              value={printing.columnWidth[0]}
            />
          </div>

          <div className={classes.setting}>
            <b>{'글씨 크기'}</b>
            <TextField type="number" size="small" label="제목" variant="outlined"
              InputLabelProps={{ shrink: true, }}
              InputProps={{ endAdornment: <InputAdornment position="end">{'px'}</InputAdornment> }}
              inputProps={{ min: 0, step: 0.5, }}
              onChange={(event) => { setPrinting({...printing, fontSize: {...printing.fontSize, title: event.target.value}}); }}
              value={printing.fontSize.title}
            />
            <TextField type="number" size="small" label="요일" variant="outlined"
              InputLabelProps={{ shrink: true, }}
              InputProps={{ endAdornment: <InputAdornment position="end">{'px'}</InputAdornment> }}
              inputProps={{ min: 0, step: 0.5, }}
              onChange={(event) => { setPrinting({...printing, fontSize: {...printing.fontSize, day: event.target.value}}); }}
              value={printing.fontSize.day}
            />
            <TextField type="number" size="small" label="참가자" variant="outlined"
              InputLabelProps={{ shrink: true, }}
              InputProps={{ endAdornment: <InputAdornment position="end">{'px'}</InputAdornment> }}
              inputProps={{ min: 0, step: 0.5, }}
              onChange={(event) => { setPrinting({...printing, fontSize: {...printing.fontSize, attender: event.target.value}}); }}
              value={printing.fontSize.attender}
            />
          </div>
        </div>
      </div>
    </div>
  );
}